import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store';
import { selectWorkspaceData, WorkspaceState } from 'store/workspaceSlice';

import Loader from 'layout/molecules/Loader';
import Project from 'layout/molecules/Project/Project';
import { fetchArchivedProjects, unarchiveProject } from 'store/projectsThunks';

export const ProjectsArchive = () => {
    const dispatch = useDispatch<AppDispatch>();
    const workspaceData: WorkspaceState = useSelector(selectWorkspaceData);
    const archivedProjects = workspaceData.archivedProjects.projects;
    const archivedProjectsStatus = workspaceData.status.fetchArchivedProjects;

    useEffect(() => {
        dispatch(fetchArchivedProjects(workspaceData.id));
    }, [dispatch, workspaceData.id]);

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                }}
            >
                {archivedProjectsStatus === 'LOADING' ? (
                    <Loader />
                ) : (
                    archivedProjects.map((p: any) => (
                        <Project
                            key={p.id}
                            id={p.id}
                            onProjectUnarchive={() =>
                                dispatch(unarchiveProject(p.id))
                            }
                            archived
                        />
                    ))
                )}
            </div>
        </>
    );
};
